import React from 'react';
import {Route, Switch} from 'react-router';
import AuthorizationHOC from '../auth/authorizationHOC';
import PersonsManagementHOC from '../personsList/personsListHOC';
import PersonHOC from '../person/personHOC';
import DepartmentsHOC from  '../departments/departmentsHOC';
import DepartmentHOC from '../department/departmentHOC';
import PillarsHOC from '../pillars/pillarsHOC';
import PillarHOC from '../pillar/pillarHOC';
import CategoryHOC from '../category/categoryHOC';
import CategoriesHOC from '../categories/categoriesHOC';
import CriterionHOC from '../criterion/criterionHOC';
import CriteriaHOC from '../criteria/criteriaHOC';
import ScoreRecordHOC from '../scoreRecord/scoreRecordHOC';
import ScoreRecordsHOC from '../scoreRecords/scoreRecordsHOC';
import StoresHOC from '../stores/storesHOC';
import DepartmentScoresHOC from '../department/departmentScoresHOC';

const ContentRouter = (props) => {
  return (
    <Switch>
      <Route path="/score-records" component={AuthorizationHOC(['admin', 'departmentUserRole'])(ScoreRecordsHOC)}/>
      <Route path="/persons" component={AuthorizationHOC(['admin'])(PersonsManagementHOC)}/>
      <Route exact path="/person/:id" component={AuthorizationHOC(['admin'])(PersonHOC)}/>
      <Route path="/person" component={AuthorizationHOC(['admin'])(PersonHOC)}/>
      <Route path="/departments" component={AuthorizationHOC(['admin'])(DepartmentsHOC)}/>
      <Route exact path="/department/:id/scores" component={AuthorizationHOC(['admin'])(DepartmentScoresHOC)}/>
      <Route exact path="/department/:id" component={AuthorizationHOC(['admin'])(DepartmentHOC)}/>
      <Route path="/department" component={AuthorizationHOC(['admin'])(DepartmentHOC)}/>
      <Route path="/pillars" component={AuthorizationHOC(['admin'])(PillarsHOC)}/>
      <Route exact path="/pillar/:id" component={AuthorizationHOC(['admin'])(PillarHOC)}/>
      <Route path="/pillar" component={AuthorizationHOC(['admin'])(PillarHOC)}/>
      <Route path="/categories" component={AuthorizationHOC(['admin'])(CategoriesHOC)}/>
      <Route exact path="/category/:id" component={AuthorizationHOC(['admin'])(CategoryHOC)}/>
      <Route path="/category" component={AuthorizationHOC(['admin'])(CategoryHOC)}/>
      <Route path="/criteria" component={AuthorizationHOC(['admin'])(CriteriaHOC)}/>
      <Route exact path="/criterion/:id" component={AuthorizationHOC(['admin'])(CriterionHOC)}/>
      <Route path="/criterion" component={AuthorizationHOC(['admin'])(CriterionHOC)}/>
      <Route exact path="/score-record/:id" component={AuthorizationHOC(['admin', 'departmentUserRole'])(ScoreRecordHOC)}/>
      <Route path="/score-record" component={AuthorizationHOC(['admin', 'departmentUserRole'])(ScoreRecordHOC)}/>
      <Route path="/stores" component={AuthorizationHOC(['admin'])(StoresHOC)}/>
    </Switch>
  )
};


export default ContentRouter;



// WEBPACK FOOTER //
// ./src/components/routers/contentRouter.js